module.exports = [
	{
		"name": "vehicle",
		"qualifiedName": "vehicle",
		"displayName": "Vehicle",
		"children": [
			{
				"name": "bikes",
				"qualifiedName": "vehicle.bikes",
				"displayName": "Bikes",
				"children": [
					{
						"name": "honda",
						"qualifiedName": "vehicle.bikes.honda",
						"displayName": "Honda",
						"children": [
							{
								"name": "activa",
								"qualifiedName": "vehicle.bikes.honda.activa",
								"displayName": "Activa",
								"children": [],
								"score": 0,
								"description": "Activa",
								"identifier": 1,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "cbShine",
								"qualifiedName": "vehicle.bikes.honda.cbShine",
								"displayName": "CB Shine",
								"children": [],
								"score": 1,
								"description": "CB Shine",
								"identifier": 2,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "cbUnicorn",
								"qualifiedName": "vehicle.bikes.honda.cbUnicorn",
								"displayName": "CB Unicorn",
								"children": [],
								"score": 2,
								"description": "CB Unicorn",
								"identifier": 3,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "dio",
								"qualifiedName": "vehicle.bikes.honda.dio",
								"displayName": "Dio",
								"children": [],
								"score": 3,
								"description": "Dio",
								"identifier": 4,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "livo",
								"qualifiedName": "vehicle.bikes.honda.livo",
								"displayName": "Livo",
								"children": [],
								"score": 4,
								"description": "Livo",
								"identifier": 5,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "cbr150",
								"qualifiedName": "vehicle.bikes.honda.cbr150",
								"displayName": "CBR 150",
								"children": [],
								"score": 5,
								"description": "CBR 150",
								"identifier": 6,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "cbTrigger",
								"qualifiedName": "vehicle.bikes.honda.cbTrigger",
								"displayName": "CB Trigger",
								"children": [],
								"score": 6,
								"description": "CB Trigger",
								"identifier": 7,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "cbr250",
								"qualifiedName": "vehicle.bikes.honda.cbr250",
								"displayName": "CBR 250",
								"children": [],
								"score": 7,
								"description": "CBR 250",
								"identifier": 8,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "dreamYuga",
								"qualifiedName": "vehicle.bikes.honda.dreamYuga",
								"displayName": "Dream Yuga",
								"children": [],
								"score": 8,
								"description": "Dream Yuga",
								"identifier": 9,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "cbTwister",
								"qualifiedName": "vehicle.bikes.honda.cbTwister",
								"displayName": "CB Twister",
								"children": [],
								"score": 9,
								"description": "CB Twister",
								"identifier": 10,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "aviator",
								"qualifiedName": "vehicle.bikes.honda.aviator",
								"displayName": "Aviator",
								"children": [],
								"score": 10,
								"description": "Aviator",
								"identifier": 11,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "cbfStunner",
								"qualifiedName": "vehicle.bikes.honda.cbfStunner",
								"displayName": "CBF Stunner",
								"children": [],
								"score": 11,
								"description": "CBF Stunner",
								"identifier": 12,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "dreamNeo",
								"qualifiedName": "vehicle.bikes.honda.dreamNeo",
								"displayName": "Dream Neo",
								"children": [],
								"score": 12,
								"description": "Dream Neo",
								"identifier": 13,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "cd110Dream",
								"qualifiedName": "vehicle.bikes.honda.cd110Dream",
								"displayName": "CD 110 Dream",
								"children": [],
								"score": 13,
								"description": "CD 110 Dream",
								"identifier": 14,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "cbr1000Rr",
								"qualifiedName": "vehicle.bikes.honda.cbr1000Rr",
								"displayName": "CBR 1000 RR",
								"children": [],
								"score": 14,
								"description": "CBR 1000 RR",
								"identifier": 15,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "cbr650F",
								"qualifiedName": "vehicle.bikes.honda.cbr650F",
								"displayName": "CBR 650 F",
								"children": [],
								"score": 15,
								"description": "CBR 650 F",
								"identifier": 16,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "goldWingGl1800",
								"qualifiedName": "vehicle.bikes.honda.goldWingGl1800",
								"displayName": "Gold Wing GL 1800",
								"children": [],
								"score": 16,
								"description": "Gold Wing GL 1800",
								"identifier": 17,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "vt1300Cx",
								"qualifiedName": "vehicle.bikes.honda.vt1300Cx",
								"displayName": "VT 1300CX",
								"children": [],
								"score": 17,
								"description": "VT 1300CX",
								"identifier": 18,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "cb1000R",
								"qualifiedName": "vehicle.bikes.honda.cb1000R",
								"displayName": "CB 1000 R",
								"children": [],
								"score": 18,
								"description": "CB 1000 R",
								"identifier": 19,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "vfr1200F",
								"qualifiedName": "vehicle.bikes.honda.vfr1200F",
								"displayName": "VFR 1200 F",
								"children": [],
								"score": 19,
								"description": "VFR 1200 F",
								"identifier": 20,
								"item_id": 42,
								"version": "1"
							}
						],
						"score": 0
					},
					{
						"name": "bajaj",
						"qualifiedName": "vehicle.bikes.bajaj",
						"displayName": "Bajaj",
						"children": [
							{
								"name": "pulsarDtShyphenI",
								"qualifiedName": "vehicle.bikes.bajaj.pulsarDtShyphenI",
								"displayName": "Pulsar DTS- i",
								"children": [],
								"score": 20,
								"description": "Pulsar DTS- i",
								"identifier": 21,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "pulsarRs200",
								"qualifiedName": "vehicle.bikes.bajaj.pulsarRs200",
								"displayName": "Pulsar RS 200",
								"children": [],
								"score": 21,
								"description": "Pulsar RS 200",
								"identifier": 22,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "pulsar220F",
								"qualifiedName": "vehicle.bikes.bajaj.pulsar220F",
								"displayName": "Pulsar 220 F",
								"children": [],
								"score": 22,
								"description": "Pulsar 220 F",
								"identifier": 23,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "pulsarNs200",
								"qualifiedName": "vehicle.bikes.bajaj.pulsarNs200",
								"displayName": "Pulsar NS 200",
								"children": [],
								"score": 23,
								"description": "Pulsar NS 200",
								"identifier": 24,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "pulsar135",
								"qualifiedName": "vehicle.bikes.bajaj.pulsar135",
								"displayName": "Pulsar 135",
								"children": [],
								"score": 24,
								"description": "Pulsar 135",
								"identifier": 25,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "ct100",
								"qualifiedName": "vehicle.bikes.bajaj.ct100",
								"displayName": "CT 100",
								"children": [],
								"score": 25,
								"description": "CT 100",
								"identifier": 26,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "platina",
								"qualifiedName": "vehicle.bikes.bajaj.platina",
								"displayName": "Platina",
								"children": [],
								"score": 26,
								"description": "Platina",
								"identifier": 27,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "avenger",
								"qualifiedName": "vehicle.bikes.bajaj.avenger",
								"displayName": "Avenger",
								"children": [],
								"score": 27,
								"description": "Avenger",
								"identifier": 28,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "pulsarAs",
								"qualifiedName": "vehicle.bikes.bajaj.pulsarAs",
								"displayName": "Pulsar AS",
								"children": [],
								"score": 28,
								"description": "Pulsar AS",
								"identifier": 29,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "discover",
								"qualifiedName": "vehicle.bikes.bajaj.discover",
								"displayName": "Discover",
								"children": [],
								"score": 29,
								"description": "Discover",
								"identifier": 30,
								"item_id": 42,
								"version": "1"
							}
						],
						"score": 20
					},
					{
						"name": "hero",
						"qualifiedName": "vehicle.bikes.hero",
						"displayName": "Hero",
						"children": [
							{
								"name": "splendor",
								"qualifiedName": "vehicle.bikes.hero.splendor",
								"displayName": "Splendor",
								"children": [],
								"score": 30,
								"description": "Splendor",
								"identifier": 31,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "passion",
								"qualifiedName": "vehicle.bikes.hero.passion",
								"displayName": "Passion",
								"children": [],
								"score": 31,
								"description": "Passion",
								"identifier": 32,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "maestro",
								"qualifiedName": "vehicle.bikes.hero.maestro",
								"displayName": "Maestro",
								"children": [],
								"score": 32,
								"description": "Maestro",
								"identifier": 33,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "glamour",
								"qualifiedName": "vehicle.bikes.hero.glamour",
								"displayName": "Glamour",
								"children": [],
								"score": 33,
								"description": "Glamour",
								"identifier": 34,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "pleasure",
								"qualifiedName": "vehicle.bikes.hero.pleasure",
								"displayName": "Pleasure",
								"children": [],
								"score": 34,
								"description": "Pleasure",
								"identifier": 35,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "splendorClassic",
								"qualifiedName": "vehicle.bikes.hero.splendorClassic",
								"displayName": "Splendor Classic",
								"children": [],
								"score": 35,
								"description": "Splendor Classic",
								"identifier": 36,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "hfDeluxe",
								"qualifiedName": "vehicle.bikes.hero.hfDeluxe",
								"displayName": "HF Deluxe",
								"children": [],
								"score": 36,
								"description": "HF Deluxe",
								"identifier": 37,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "hunk",
								"qualifiedName": "vehicle.bikes.hero.hunk",
								"displayName": "Hunk",
								"children": [],
								"score": 37,
								"description": "Hunk",
								"identifier": 38,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "ignitor",
								"qualifiedName": "vehicle.bikes.hero.ignitor",
								"displayName": "Ignitor",
								"children": [],
								"score": 38,
								"description": "Ignitor",
								"identifier": 39,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "karizma",
								"qualifiedName": "vehicle.bikes.hero.karizma",
								"displayName": "Karizma",
								"children": [],
								"score": 39,
								"description": "Karizma",
								"identifier": 40,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "xtreme",
								"qualifiedName": "vehicle.bikes.hero.xtreme",
								"displayName": "Xtreme",
								"children": [],
								"score": 40,
								"description": "Xtreme",
								"identifier": 41,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "hfDawn",
								"qualifiedName": "vehicle.bikes.hero.hfDawn",
								"displayName": "HF Dawn",
								"children": [],
								"score": 41,
								"description": "HF Dawn",
								"identifier": 42,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "achiever",
								"qualifiedName": "vehicle.bikes.hero.achiever",
								"displayName": "Achiever",
								"children": [],
								"score": 42,
								"description": "Achiever",
								"identifier": 43,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "impulse",
								"qualifiedName": "vehicle.bikes.hero.impulse",
								"displayName": "Impulse",
								"children": [],
								"score": 43,
								"description": "Impulse",
								"identifier": 44,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "duet",
								"qualifiedName": "vehicle.bikes.hero.duet",
								"displayName": "Duet",
								"children": [],
								"score": 44,
								"description": "Duet",
								"identifier": 45,
								"item_id": 42,
								"version": "1"
							}
						],
						"score": 30
					},
					{
						"name": "tvsMotors",
						"qualifiedName": "vehicle.bikes.tvsMotors",
						"displayName": "TVS Motors",
						"children": [
							{
								"name": "apacheRtr",
								"qualifiedName": "vehicle.bikes.tvsMotors.apacheRtr",
								"displayName": "Apache RTR",
								"children": [],
								"score": 45,
								"description": "Apache RTR",
								"identifier": 46,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "jupiter",
								"qualifiedName": "vehicle.bikes.tvsMotors.jupiter",
								"displayName": "Jupiter",
								"children": [],
								"score": 46,
								"description": "Jupiter",
								"identifier": 47,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "sport",
								"qualifiedName": "vehicle.bikes.tvsMotors.sport",
								"displayName": "Sport",
								"children": [],
								"score": 47,
								"description": "Sport",
								"identifier": 48,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "starCityPlus",
								"qualifiedName": "vehicle.bikes.tvsMotors.starCityPlus",
								"displayName": "Star City Plus",
								"children": [],
								"score": 48,
								"description": "Star City Plus",
								"identifier": 49,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "heavyDutySuperXl",
								"qualifiedName": "vehicle.bikes.tvsMotors.heavyDutySuperXl",
								"displayName": "Heavy Duty Super XL",
								"children": [],
								"score": 49,
								"description": "Heavy Duty Super XL",
								"identifier": 50,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "scooty",
								"qualifiedName": "vehicle.bikes.tvsMotors.scooty",
								"displayName": "Scooty",
								"children": [],
								"score": 50,
								"description": "Scooty",
								"identifier": 51,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "wego",
								"qualifiedName": "vehicle.bikes.tvsMotors.wego",
								"displayName": "Wego",
								"children": [],
								"score": 51,
								"description": "Wego",
								"identifier": 52,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "phoenix",
								"qualifiedName": "vehicle.bikes.tvsMotors.phoenix",
								"displayName": "Phoenix",
								"children": [],
								"score": 52,
								"description": "Phoenix",
								"identifier": 53,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "max4R",
								"qualifiedName": "vehicle.bikes.tvsMotors.max4R",
								"displayName": "MAX4R",
								"children": [],
								"score": 53,
								"description": "MAX4R",
								"identifier": 54,
								"item_id": 42,
								"version": "1"
							}
						],
						"score": 45
					},
					{
						"name": "royalEnfield",
						"qualifiedName": "vehicle.bikes.royalEnfield",
						"displayName": "Royal Enfield",
						"children": [
							{
								"name": "classic350",
								"qualifiedName": "vehicle.bikes.royalEnfield.classic350",
								"displayName": "Classic 350",
								"children": [],
								"score": 54,
								"description": "Classic 350",
								"identifier": 55,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "thunderbird350",
								"qualifiedName": "vehicle.bikes.royalEnfield.thunderbird350",
								"displayName": "Thunderbird 350",
								"children": [],
								"score": 55,
								"description": "Thunderbird 350",
								"identifier": 56,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "bullet350",
								"qualifiedName": "vehicle.bikes.royalEnfield.bullet350",
								"displayName": "Bullet 350",
								"children": [],
								"score": 56,
								"description": "Bullet 350",
								"identifier": 57,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "bulletElectra",
								"qualifiedName": "vehicle.bikes.royalEnfield.bulletElectra",
								"displayName": "Bullet Electra",
								"children": [],
								"score": 57,
								"description": "Bullet Electra",
								"identifier": 58,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "classic500",
								"qualifiedName": "vehicle.bikes.royalEnfield.classic500",
								"displayName": "Classic 500",
								"children": [],
								"score": 58,
								"description": "Classic 500",
								"identifier": 59,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "thunderbird500",
								"qualifiedName": "vehicle.bikes.royalEnfield.thunderbird500",
								"displayName": "Thunderbird 500",
								"children": [],
								"score": 59,
								"description": "Thunderbird 500",
								"identifier": 60,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "continentalGtCafeRacer",
								"qualifiedName": "vehicle.bikes.royalEnfield.continentalGtCafeRacer",
								"displayName": "Continental GT (Cafe Racer)",
								"children": [],
								"score": 60,
								"description": "Continental GT (Cafe Racer)",
								"identifier": 61,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "bullet500",
								"qualifiedName": "vehicle.bikes.royalEnfield.bullet500",
								"displayName": "Bullet 500",
								"children": [],
								"score": 61,
								"description": "Bullet 500",
								"identifier": 62,
								"item_id": 42,
								"version": "1"
							}
						],
						"score": 54
					},
					{
						"name": "yamaha",
						"qualifiedName": "vehicle.bikes.yamaha",
						"displayName": "Yamaha",
						"children": [
							{
								"name": "fzS",
								"qualifiedName": "vehicle.bikes.yamaha.fzS",
								"displayName": "FZ S",
								"children": [],
								"score": 62,
								"description": "FZ S",
								"identifier": 63,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "yzfR15",
								"qualifiedName": "vehicle.bikes.yamaha.yzfR15",
								"displayName": "YZF R15",
								"children": [],
								"score": 63,
								"description": "YZF R15",
								"identifier": 64,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "fazer",
								"qualifiedName": "vehicle.bikes.yamaha.fazer",
								"displayName": "Fazer",
								"children": [],
								"score": 64,
								"description": "Fazer",
								"identifier": 65,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "fz",
								"qualifiedName": "vehicle.bikes.yamaha.fz",
								"displayName": "FZ",
								"children": [],
								"score": 65,
								"description": "FZ",
								"identifier": 66,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "szRr",
								"qualifiedName": "vehicle.bikes.yamaha.szRr",
								"displayName": "SZ RR",
								"children": [],
								"score": 66,
								"description": "SZ RR",
								"identifier": 67,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "yzFhyphenR3",
								"qualifiedName": "vehicle.bikes.yamaha.yzFhyphenR3",
								"displayName": "YZF-R3",
								"children": [],
								"score": 67,
								"description": "YZF-R3",
								"identifier": 68,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "crux",
								"qualifiedName": "vehicle.bikes.yamaha.crux",
								"displayName": "Crux",
								"children": [],
								"score": 68,
								"description": "Crux",
								"identifier": 69,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "saluto",
								"qualifiedName": "vehicle.bikes.yamaha.saluto",
								"displayName": "Saluto",
								"children": [],
								"score": 69,
								"description": "Saluto",
								"identifier": 70,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "ray",
								"qualifiedName": "vehicle.bikes.yamaha.ray",
								"displayName": "Ray",
								"children": [],
								"score": 70,
								"description": "Ray",
								"identifier": 71,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "alpha",
								"qualifiedName": "vehicle.bikes.yamaha.alpha",
								"displayName": "Alpha",
								"children": [],
								"score": 71,
								"description": "Alpha",
								"identifier": 72,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "fascino",
								"qualifiedName": "vehicle.bikes.yamaha.fascino",
								"displayName": "Fascino",
								"children": [],
								"score": 72,
								"description": "Fascino",
								"identifier": 73,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "vmax",
								"qualifiedName": "vehicle.bikes.yamaha.vmax",
								"displayName": "Vmax",
								"children": [],
								"score": 73,
								"description": "Vmax",
								"identifier": 74,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "yzfR1",
								"qualifiedName": "vehicle.bikes.yamaha.yzfR1",
								"displayName": "YZF R1",
								"children": [],
								"score": 74,
								"description": "YZF R1",
								"identifier": 75,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "fz1",
								"qualifiedName": "vehicle.bikes.yamaha.fz1",
								"displayName": "FZ1",
								"children": [],
								"score": 75,
								"description": "FZ1",
								"identifier": 76,
								"item_id": 42,
								"version": "1"
							}
						],
						"score": 62
					},
					{
						"name": "suzuki",
						"qualifiedName": "vehicle.bikes.suzuki",
						"displayName": "Suzuki",
						"children": [
							{
								"name": "gixxer",
								"qualifiedName": "vehicle.bikes.suzuki.gixxer",
								"displayName": "Gixxer",
								"children": [],
								"score": 76,
								"description": "Gixxer",
								"identifier": 77,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "gixxerSf",
								"qualifiedName": "vehicle.bikes.suzuki.gixxerSf",
								"displayName": "Gixxer SF",
								"children": [],
								"score": 77,
								"description": "Gixxer SF",
								"identifier": 78,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "gs150R",
								"qualifiedName": "vehicle.bikes.suzuki.gs150R",
								"displayName": "GS150R",
								"children": [],
								"score": 78,
								"description": "GS150R",
								"identifier": 79,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "hayate",
								"qualifiedName": "vehicle.bikes.suzuki.hayate",
								"displayName": "Hayate",
								"children": [],
								"score": 79,
								"description": "Hayate",
								"identifier": 80,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "slingShotPlus",
								"qualifiedName": "vehicle.bikes.suzuki.slingShotPlus",
								"displayName": "SlingShot Plus",
								"children": [],
								"score": 80,
								"description": "SlingShot Plus",
								"identifier": 81,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "swish125Facelift",
								"qualifiedName": "vehicle.bikes.suzuki.swish125Facelift",
								"displayName": "Swish 125 facelift",
								"children": [],
								"score": 81,
								"description": "Swish 125 facelift",
								"identifier": 82,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "letS",
								"qualifiedName": "vehicle.bikes.suzuki.letS",
								"displayName": "Let's",
								"children": [],
								"score": 82,
								"description": "Let's",
								"identifier": 83,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "access",
								"qualifiedName": "vehicle.bikes.suzuki.access",
								"displayName": "Access",
								"children": [],
								"score": 83,
								"description": "Access",
								"identifier": 84,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "gsXhyphenR1000",
								"qualifiedName": "vehicle.bikes.suzuki.gsXhyphenR1000",
								"displayName": "GSX-R1000",
								"children": [],
								"score": 84,
								"description": "GSX-R1000",
								"identifier": 85,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "m1800R",
								"qualifiedName": "vehicle.bikes.suzuki.m1800R",
								"displayName": "M1800R",
								"children": [],
								"score": 85,
								"description": "M1800R",
								"identifier": 86,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "m800",
								"qualifiedName": "vehicle.bikes.suzuki.m800",
								"displayName": "M800",
								"children": [],
								"score": 86,
								"description": "M800",
								"identifier": 87,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "gsXhyphenS1000",
								"qualifiedName": "vehicle.bikes.suzuki.gsXhyphenS1000",
								"displayName": "GSX-S1000",
								"children": [],
								"score": 87,
								"description": "GSX-S1000",
								"identifier": 88,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "bandit",
								"qualifiedName": "vehicle.bikes.suzuki.bandit",
								"displayName": "Bandit",
								"children": [],
								"score": 88,
								"description": "Bandit",
								"identifier": 89,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "hayabusa",
								"qualifiedName": "vehicle.bikes.suzuki.hayabusa",
								"displayName": "Hayabusa",
								"children": [],
								"score": 89,
								"description": "Hayabusa",
								"identifier": 90,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "vhyphenStrom1000",
								"qualifiedName": "vehicle.bikes.suzuki.vhyphenStrom1000",
								"displayName": "V-Strom 1000",
								"children": [],
								"score": 90,
								"description": "V-Strom 1000",
								"identifier": 91,
								"item_id": 42,
								"version": "1"
							}
						],
						"score": 76
					},
					{
						"name": "ktm",
						"qualifiedName": "vehicle.bikes.ktm",
						"displayName": "KTM",
						"children": [
							{
								"name": "duke200",
								"qualifiedName": "vehicle.bikes.ktm.duke200",
								"displayName": "Duke 200",
								"children": [],
								"score": 91,
								"description": "Duke 200",
								"identifier": 92,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "rc200",
								"qualifiedName": "vehicle.bikes.ktm.rc200",
								"displayName": "RC200",
								"children": [],
								"score": 92,
								"description": "RC200",
								"identifier": 93,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "390DukeAbs",
								"qualifiedName": "vehicle.bikes.ktm.390DukeAbs",
								"displayName": "390 Duke ABS",
								"children": [],
								"score": 93,
								"description": "390 Duke ABS",
								"identifier": 94,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "rc390",
								"qualifiedName": "vehicle.bikes.ktm.rc390",
								"displayName": "RC390",
								"children": [],
								"score": 94,
								"description": "RC390",
								"identifier": 95,
								"item_id": 42,
								"version": "1"
							}
						],
						"score": 91
					},
					{
						"name": "mahindra",
						"qualifiedName": "vehicle.bikes.mahindra",
						"displayName": "Mahindra",
						"children": [
							{
								"name": "gusto",
								"qualifiedName": "vehicle.bikes.mahindra.gusto",
								"displayName": "Gusto",
								"children": [],
								"score": 95,
								"description": "Gusto",
								"identifier": 96,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "rodeo",
								"qualifiedName": "vehicle.bikes.mahindra.rodeo",
								"displayName": "Rodeo",
								"children": [],
								"score": 96,
								"description": "Rodeo",
								"identifier": 97,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "centuro",
								"qualifiedName": "vehicle.bikes.mahindra.centuro",
								"displayName": "Centuro",
								"children": [],
								"score": 97,
								"description": "Centuro",
								"identifier": 98,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "duro",
								"qualifiedName": "vehicle.bikes.mahindra.duro",
								"displayName": "Duro",
								"children": [],
								"score": 98,
								"description": "Duro",
								"identifier": 99,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "mojo",
								"qualifiedName": "vehicle.bikes.mahindra.mojo",
								"displayName": "Mojo",
								"children": [],
								"score": 99,
								"description": "Mojo",
								"identifier": 100,
								"item_id": 42,
								"version": "1"
							}
						],
						"score": 95
					},
					{
						"name": "kawasaki",
						"qualifiedName": "vehicle.bikes.kawasaki",
						"displayName": "Kawasaki",
						"children": [
							{
								"name": "ninja300",
								"qualifiedName": "vehicle.bikes.kawasaki.ninja300",
								"displayName": "Ninja 300",
								"children": [],
								"score": 100,
								"description": "Ninja 300",
								"identifier": 101,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "ninja650R",
								"qualifiedName": "vehicle.bikes.kawasaki.ninja650R",
								"displayName": "Ninja 650 R",
								"children": [],
								"score": 101,
								"description": "Ninja 650 R",
								"identifier": 102,
								"item_id": 42,
								"version": "1"
							}
						],
						"score": 100
					},
					{
						"name": "harleyDavidson",
						"qualifiedName": "vehicle.bikes.harleyDavidson",
						"displayName": "Harley Davidson",
						"children": [
							{
								"name": "street750",
								"qualifiedName": "vehicle.bikes.harleyDavidson.street750",
								"displayName": "Street 750",
								"children": [],
								"score": 102,
								"description": "Street 750",
								"identifier": 103,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "iron883",
								"qualifiedName": "vehicle.bikes.harleyDavidson.iron883",
								"displayName": "Iron 883",
								"children": [],
								"score": 103,
								"description": "Iron 883",
								"identifier": 104,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "superLow",
								"qualifiedName": "vehicle.bikes.harleyDavidson.superLow",
								"displayName": "SuperLow",
								"children": [],
								"score": 104,
								"description": "SuperLow",
								"identifier": 105,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "fortyEight",
								"qualifiedName": "vehicle.bikes.harleyDavidson.fortyEight",
								"displayName": "Forty Eight",
								"children": [],
								"score": 105,
								"description": "Forty Eight",
								"identifier": 106,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "vRod",
								"qualifiedName": "vehicle.bikes.harleyDavidson.vRod",
								"displayName": "V Rod",
								"children": [],
								"score": 106,
								"description": "V Rod",
								"identifier": 107,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "cvoLimited",
								"qualifiedName": "vehicle.bikes.harleyDavidson.cvoLimited",
								"displayName": "CVO Limited",
								"children": [],
								"score": 107,
								"description": "CVO Limited",
								"identifier": 108,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "fatBoy",
								"qualifiedName": "vehicle.bikes.harleyDavidson.fatBoy",
								"displayName": "Fat Boy",
								"children": [],
								"score": 108,
								"description": "Fat Boy",
								"identifier": 109,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "fatBob",
								"qualifiedName": "vehicle.bikes.harleyDavidson.fatBob",
								"displayName": "Fat Bob",
								"children": [],
								"score": 109,
								"description": "Fat Bob",
								"identifier": 110,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "streetBob",
								"qualifiedName": "vehicle.bikes.harleyDavidson.streetBob",
								"displayName": "Street Bob",
								"children": [],
								"score": 110,
								"description": "Street Bob",
								"identifier": 111,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "fatBoySpecial",
								"qualifiedName": "vehicle.bikes.harleyDavidson.fatBoySpecial",
								"displayName": "Fat Boy Special",
								"children": [],
								"score": 111,
								"description": "Fat Boy Special",
								"identifier": 112,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "breakout",
								"qualifiedName": "vehicle.bikes.harleyDavidson.breakout",
								"displayName": "Breakout",
								"children": [],
								"score": 112,
								"description": "Breakout",
								"identifier": 113,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "roadKing2016",
								"qualifiedName": "vehicle.bikes.harleyDavidson.roadKing2016",
								"displayName": "Road King 2016",
								"children": [],
								"score": 113,
								"description": "Road King 2016",
								"identifier": 114,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "heritageSoftailClassic",
								"qualifiedName": "vehicle.bikes.harleyDavidson.heritageSoftailClassic",
								"displayName": "Heritage Softail Classic",
								"children": [],
								"score": 114,
								"description": "Heritage Softail Classic",
								"identifier": 115,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "streetGlideSpecial",
								"qualifiedName": "vehicle.bikes.harleyDavidson.streetGlideSpecial",
								"displayName": "Street Glide Special",
								"children": [],
								"score": 115,
								"description": "Street Glide Special",
								"identifier": 116,
								"item_id": 42,
								"version": "1"
							}
						],
						"score": 102
					},
					{
						"name": "bmw",
						"qualifiedName": "vehicle.bikes.bmw",
						"displayName": "BMW",
						"children": [
							{
								"name": "s1000Rr",
								"qualifiedName": "vehicle.bikes.bmw.s1000Rr",
								"displayName": "S1000 RR",
								"children": [],
								"score": 116,
								"description": "S1000 RR",
								"identifier": 117,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "k1300",
								"qualifiedName": "vehicle.bikes.bmw.k1300",
								"displayName": "K 1300",
								"children": [],
								"score": 117,
								"description": "K 1300",
								"identifier": 118,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "k1600",
								"qualifiedName": "vehicle.bikes.bmw.k1600",
								"displayName": "K1600",
								"children": [],
								"score": 118,
								"description": "K1600",
								"identifier": 119,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "s1000R",
								"qualifiedName": "vehicle.bikes.bmw.s1000R",
								"displayName": "S 1000 R",
								"children": [],
								"score": 119,
								"description": "S 1000 R",
								"identifier": 120,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "rNineT",
								"qualifiedName": "vehicle.bikes.bmw.rNineT",
								"displayName": "R nineT",
								"children": [],
								"score": 120,
								"description": "R nineT",
								"identifier": 121,
								"item_id": 42,
								"version": "1"
							},
							{
								"name": "r1200",
								"qualifiedName": "vehicle.bikes.bmw.r1200",
								"displayName": "R1200",
								"children": [],
								"score": 121,
								"description": "R1200",
								"identifier": 122,
								"item_id": 42,
								"version": "1"
							}
						],
						"score": 116
					}
				],
				"score": 0,
				"item_id": 42
			},
			{
				"name": "cars",
				"qualifiedName": "vehicle.cars",
				"displayName": "Cars",
				"children": [
					{
						"name": "marutiSuzuki",
						"qualifiedName": "vehicle.cars.marutiSuzuki",
						"displayName": "Maruti Suzuki",
						"children": [
							{
								"name": "alto",
								"qualifiedName": "vehicle.cars.marutiSuzuki.alto",
								"displayName": "Alto",
								"children": [],
								"score": 122,
								"description": "Alto",
								"identifier": 123,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "wagonR",
								"qualifiedName": "vehicle.cars.marutiSuzuki.wagonR",
								"displayName": "Wagon R",
								"children": [],
								"score": 123,
								"description": "Wagon R",
								"identifier": 124,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "celerio",
								"qualifiedName": "vehicle.cars.marutiSuzuki.celerio",
								"displayName": "Celerio",
								"children": [],
								"score": 124,
								"description": "Celerio",
								"identifier": 125,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "ritz",
								"qualifiedName": "vehicle.cars.marutiSuzuki.ritz",
								"displayName": "Ritz",
								"children": [],
								"score": 125,
								"description": "Ritz",
								"identifier": 126,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "swift",
								"qualifiedName": "vehicle.cars.marutiSuzuki.swift",
								"displayName": "Swift",
								"children": [],
								"score": 126,
								"description": "Swift",
								"identifier": 127,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "swiftDzire",
								"qualifiedName": "vehicle.cars.marutiSuzuki.swiftDzire",
								"displayName": "Swift Dzire",
								"children": [],
								"score": 127,
								"description": "Swift Dzire",
								"identifier": 128,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "ertiga",
								"qualifiedName": "vehicle.cars.marutiSuzuki.ertiga",
								"displayName": "Ertiga",
								"children": [],
								"score": 128,
								"description": "Ertiga",
								"identifier": 129,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "ciaz",
								"qualifiedName": "vehicle.cars.marutiSuzuki.ciaz",
								"displayName": "Ciaz",
								"children": [],
								"score": 129,
								"description": "Ciaz",
								"identifier": 130,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "shyphenCross",
								"qualifiedName": "vehicle.cars.marutiSuzuki.shyphenCross",
								"displayName": "S-Cross",
								"children": [],
								"score": 130,
								"description": "S-Cross",
								"identifier": 131,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "omni",
								"qualifiedName": "vehicle.cars.marutiSuzuki.omni",
								"displayName": "Omni",
								"children": [],
								"score": 131,
								"description": "Omni",
								"identifier": 132,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "800",
								"qualifiedName": "vehicle.cars.marutiSuzuki.800",
								"displayName": "800",
								"children": [],
								"score": 132,
								"description": "800",
								"identifier": 133,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "baleno",
								"qualifiedName": "vehicle.cars.marutiSuzuki.baleno",
								"displayName": "Baleno",
								"children": [],
								"score": 133,
								"description": "Baleno",
								"identifier": 134,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "ahyphenstar",
								"qualifiedName": "vehicle.cars.marutiSuzuki.ahyphenstar",
								"displayName": "A-star",
								"children": [],
								"score": 134,
								"description": "A-star",
								"identifier": 135,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "zenEstilo",
								"qualifiedName": "vehicle.cars.marutiSuzuki.zenEstilo",
								"displayName": "Zen estilo",
								"children": [],
								"score": 135,
								"description": "Zen estilo",
								"identifier": 136,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "esteem",
								"qualifiedName": "vehicle.cars.marutiSuzuki.esteem",
								"displayName": "Esteem",
								"children": [],
								"score": 136,
								"description": "Esteem",
								"identifier": 137,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "eeco",
								"qualifiedName": "vehicle.cars.marutiSuzuki.eeco",
								"displayName": "Eeco",
								"children": [],
								"score": 137,
								"description": "Eeco",
								"identifier": 138,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "versa",
								"qualifiedName": "vehicle.cars.marutiSuzuki.versa",
								"displayName": "Versa",
								"children": [],
								"score": 138,
								"description": "Versa",
								"identifier": 139,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "gypsy",
								"qualifiedName": "vehicle.cars.marutiSuzuki.gypsy",
								"displayName": "Gypsy",
								"children": [],
								"score": 139,
								"description": "Gypsy",
								"identifier": 140,
								"item_id": 41,
								"version": "1"
							}
						],
						"score": 122
					},
					{
						"name": "hyundai",
						"qualifiedName": "vehicle.cars.hyundai",
						"displayName": "Hyundai",
						"children": [
							{
								"name": "eon",
								"qualifiedName": "vehicle.cars.hyundai.eon",
								"displayName": "Eon",
								"children": [],
								"score": 140,
								"description": "Eon",
								"identifier": 141,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "i10",
								"qualifiedName": "vehicle.cars.hyundai.i10",
								"displayName": "i10",
								"children": [],
								"score": 141,
								"description": "i10",
								"identifier": 142,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "grandI10",
								"qualifiedName": "vehicle.cars.hyundai.grandI10",
								"displayName": "Grand i10",
								"children": [],
								"score": 142,
								"description": "Grand i10",
								"identifier": 143,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "xcent",
								"qualifiedName": "vehicle.cars.hyundai.xcent",
								"displayName": "Xcent",
								"children": [],
								"score": 143,
								"description": "Xcent",
								"identifier": 144,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "i20",
								"qualifiedName": "vehicle.cars.hyundai.i20",
								"displayName": "i20",
								"children": [],
								"score": 144,
								"description": "i20",
								"identifier": 145,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "verna",
								"qualifiedName": "vehicle.cars.hyundai.verna",
								"displayName": "Verna",
								"children": [],
								"score": 145,
								"description": "Verna",
								"identifier": 146,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "creta",
								"qualifiedName": "vehicle.cars.hyundai.creta",
								"displayName": "Creta",
								"children": [],
								"score": 146,
								"description": "Creta",
								"identifier": 147,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "elantra",
								"qualifiedName": "vehicle.cars.hyundai.elantra",
								"displayName": "Elantra",
								"children": [],
								"score": 147,
								"description": "Elantra",
								"identifier": 148,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "santro",
								"qualifiedName": "vehicle.cars.hyundai.santro",
								"displayName": "Santro",
								"children": [],
								"score": 148,
								"description": "Santro",
								"identifier": 149,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "sonata",
								"qualifiedName": "vehicle.cars.hyundai.sonata",
								"displayName": "Sonata",
								"children": [],
								"score": 149,
								"description": "Sonata",
								"identifier": 150,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "tucson",
								"qualifiedName": "vehicle.cars.hyundai.tucson",
								"displayName": "Tucson",
								"children": [],
								"score": 150,
								"description": "Tucson",
								"identifier": 151,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "accent",
								"qualifiedName": "vehicle.cars.hyundai.accent",
								"displayName": "Accent",
								"children": [],
								"score": 151,
								"description": "Accent",
								"identifier": 152,
								"item_id": 41,
								"version": "1"
							}
						],
						"score": 140
					},
					{
						"name": "hondaSiel",
						"qualifiedName": "vehicle.cars.hondaSiel",
						"displayName": "Honda Siel",
						"children": [
							{
								"name": "brio",
								"qualifiedName": "vehicle.cars.hondaSiel.brio",
								"displayName": "Brio",
								"children": [],
								"score": 152,
								"description": "Brio",
								"identifier": 153,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "amaze",
								"qualifiedName": "vehicle.cars.hondaSiel.amaze",
								"displayName": "Amaze",
								"children": [],
								"score": 153,
								"description": "Amaze",
								"identifier": 154,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "jazz",
								"qualifiedName": "vehicle.cars.hondaSiel.jazz",
								"displayName": "Jazz",
								"children": [],
								"score": 154,
								"description": "Jazz",
								"identifier": 155,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "mobilio",
								"qualifiedName": "vehicle.cars.hondaSiel.mobilio",
								"displayName": "Mobilio",
								"children": [],
								"score": 155,
								"description": "Mobilio",
								"identifier": 156,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "city",
								"qualifiedName": "vehicle.cars.hondaSiel.city",
								"displayName": "City",
								"children": [],
								"score": 156,
								"description": "City",
								"identifier": 157,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "cRhyphenV",
								"qualifiedName": "vehicle.cars.hondaSiel.cRhyphenV",
								"displayName": "CR-V",
								"children": [],
								"score": 157,
								"description": "CR-V",
								"identifier": 158,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "accord",
								"qualifiedName": "vehicle.cars.hondaSiel.accord",
								"displayName": "Accord",
								"children": [],
								"score": 158,
								"description": "Accord",
								"identifier": 159,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "civic",
								"qualifiedName": "vehicle.cars.hondaSiel.civic",
								"displayName": "Civic",
								"children": [],
								"score": 159,
								"description": "Civic",
								"identifier": 160,
								"item_id": 41,
								"version": "1"
							}
						],
						"score": 152
					},
					{
						"name": "mahindra",
						"qualifiedName": "vehicle.cars.mahindra",
						"displayName": "Mahindra",
						"children": [
							{
								"name": "thar",
								"qualifiedName": "vehicle.cars.mahindra.thar",
								"displayName": "Thar",
								"children": [],
								"score": 160,
								"description": "Thar",
								"identifier": 161,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "xuv500",
								"qualifiedName": "vehicle.cars.mahindra.xuv500",
								"displayName": "XUV500",
								"children": [],
								"score": 161,
								"description": "XUV500",
								"identifier": 162,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "xylo",
								"qualifiedName": "vehicle.cars.mahindra.xylo",
								"displayName": "Xylo",
								"children": [],
								"score": 162,
								"description": "Xylo",
								"identifier": 163,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "scorpio",
								"qualifiedName": "vehicle.cars.mahindra.scorpio",
								"displayName": "Scorpio",
								"children": [],
								"score": 163,
								"description": "Scorpio",
								"identifier": 164,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "e2O",
								"qualifiedName": "vehicle.cars.mahindra.e2O",
								"displayName": "e2o",
								"children": [],
								"score": 164,
								"description": "e2o",
								"identifier": 165,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "veritoVibe",
								"qualifiedName": "vehicle.cars.mahindra.veritoVibe",
								"displayName": "Verito Vibe",
								"children": [],
								"score": 165,
								"description": "Verito Vibe",
								"identifier": 166,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "bolero",
								"qualifiedName": "vehicle.cars.mahindra.bolero",
								"displayName": "Bolero",
								"children": [],
								"score": 166,
								"description": "Bolero",
								"identifier": 167,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "quanto",
								"qualifiedName": "vehicle.cars.mahindra.quanto",
								"displayName": "Quanto",
								"children": [],
								"score": 167,
								"description": "Quanto",
								"identifier": 168,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "verito",
								"qualifiedName": "vehicle.cars.mahindra.verito",
								"displayName": "Verito",
								"children": [],
								"score": 168,
								"description": "Verito",
								"identifier": 169,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "tuv300",
								"qualifiedName": "vehicle.cars.mahindra.tuv300",
								"displayName": "TUV300",
								"children": [],
								"score": 169,
								"description": "TUV300",
								"identifier": 170,
								"item_id": 41,
								"version": "1"
							}
						],
						"score": 160
					},
					{
						"name": "toyota",
						"qualifiedName": "vehicle.cars.toyota",
						"displayName": "Toyota",
						"children": [
							{
								"name": "etiosLiva",
								"qualifiedName": "vehicle.cars.toyota.etiosLiva",
								"displayName": "Etios Liva",
								"children": [],
								"score": 170,
								"description": "Etios Liva",
								"identifier": 171,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "etios",
								"qualifiedName": "vehicle.cars.toyota.etios",
								"displayName": "Etios",
								"children": [],
								"score": 171,
								"description": "Etios",
								"identifier": 172,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "qualis",
								"qualifiedName": "vehicle.cars.toyota.qualis",
								"displayName": "Qualis",
								"children": [],
								"score": 172,
								"description": "Qualis",
								"identifier": 173,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "innova",
								"qualifiedName": "vehicle.cars.toyota.innova",
								"displayName": "Innova",
								"children": [],
								"score": 173,
								"description": "Innova",
								"identifier": 174,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "corollaAltis",
								"qualifiedName": "vehicle.cars.toyota.corollaAltis",
								"displayName": "Corolla Altis",
								"children": [],
								"score": 174,
								"description": "Corolla Altis",
								"identifier": 175,
								"item_id": 41,
								"version": "1"
							}
						],
						"score": 170
					},
					{
						"name": "tataMotors",
						"qualifiedName": "vehicle.cars.tataMotors",
						"displayName": "Tata Motors",
						"children": [
							{
								"name": "nano",
								"qualifiedName": "vehicle.cars.tataMotors.nano",
								"displayName": "Nano",
								"children": [],
								"score": 175,
								"description": "Nano",
								"identifier": 176,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "indica",
								"qualifiedName": "vehicle.cars.tataMotors.indica",
								"displayName": "Indica",
								"children": [],
								"score": 176,
								"description": "Indica",
								"identifier": 177,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "bolt",
								"qualifiedName": "vehicle.cars.tataMotors.bolt",
								"displayName": "Bolt",
								"children": [],
								"score": 177,
								"description": "Bolt",
								"identifier": 178,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "zest",
								"qualifiedName": "vehicle.cars.tataMotors.zest",
								"displayName": "Zest",
								"children": [],
								"score": 178,
								"description": "Zest",
								"identifier": 179,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "indigoECs",
								"qualifiedName": "vehicle.cars.tataMotors.indigoECs",
								"displayName": "Indigo eCS",
								"children": [],
								"score": 179,
								"description": "Indigo eCS",
								"identifier": 180,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "manza",
								"qualifiedName": "vehicle.cars.tataMotors.manza",
								"displayName": "Manza",
								"children": [],
								"score": 180,
								"description": "Manza",
								"identifier": 181,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "sumo",
								"qualifiedName": "vehicle.cars.tataMotors.sumo",
								"displayName": "Sumo",
								"children": [],
								"score": 181,
								"description": "Sumo",
								"identifier": 182,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "safari",
								"qualifiedName": "vehicle.cars.tataMotors.safari",
								"displayName": "Safari",
								"children": [],
								"score": 182,
								"description": "Safari",
								"identifier": 183,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "xenonXt",
								"qualifiedName": "vehicle.cars.tataMotors.xenonXt",
								"displayName": "Xenon XT",
								"children": [],
								"score": 183,
								"description": "Xenon XT",
								"identifier": 184,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "aria",
								"qualifiedName": "vehicle.cars.tataMotors.aria",
								"displayName": "Aria",
								"children": [],
								"score": 184,
								"description": "Aria",
								"identifier": 185,
								"item_id": 41,
								"version": "1"
							}
						],
						"score": 175
					},
					{
						"name": "volkswagen",
						"qualifiedName": "vehicle.cars.volkswagen",
						"displayName": "Volkswagen",
						"children": [
							{
								"name": "polo",
								"qualifiedName": "vehicle.cars.volkswagen.polo",
								"displayName": "Polo",
								"children": [],
								"score": 185,
								"description": "Polo",
								"identifier": 186,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "vento",
								"qualifiedName": "vehicle.cars.volkswagen.vento",
								"displayName": "Vento",
								"children": [],
								"score": 186,
								"description": "Vento",
								"identifier": 187,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "jetta",
								"qualifiedName": "vehicle.cars.volkswagen.jetta",
								"displayName": "Jetta",
								"children": [],
								"score": 187,
								"description": "Jetta",
								"identifier": 188,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "beetle",
								"qualifiedName": "vehicle.cars.volkswagen.beetle",
								"displayName": "Beetle",
								"children": [],
								"score": 188,
								"description": "Beetle",
								"identifier": 189,
								"item_id": 41,
								"version": "1"
							}
						],
						"score": 185
					},
					{
						"name": "ford",
						"qualifiedName": "vehicle.cars.ford",
						"displayName": "Ford",
						"children": [
							{
								"name": "figo",
								"qualifiedName": "vehicle.cars.ford.figo",
								"displayName": "Figo",
								"children": [],
								"score": 189,
								"description": "Figo",
								"identifier": 190,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "figoAspire",
								"qualifiedName": "vehicle.cars.ford.figoAspire",
								"displayName": "Figo Aspire",
								"children": [],
								"score": 190,
								"description": "Figo Aspire",
								"identifier": 191,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "classic",
								"qualifiedName": "vehicle.cars.ford.classic",
								"displayName": "Classic",
								"children": [],
								"score": 191,
								"description": "Classic",
								"identifier": 192,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "ecoSport",
								"qualifiedName": "vehicle.cars.ford.ecoSport",
								"displayName": "EcoSport",
								"children": [],
								"score": 192,
								"description": "EcoSport",
								"identifier": 193,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "fiesta",
								"qualifiedName": "vehicle.cars.ford.fiesta",
								"displayName": "Fiesta",
								"children": [],
								"score": 193,
								"description": "Fiesta",
								"identifier": 194,
								"item_id": 41,
								"version": "1"
							}
						],
						"score": 189
					},
					{
						"name": "datsun",
						"qualifiedName": "vehicle.cars.datsun",
						"displayName": "Datsun",
						"children": [
							{
								"name": "go",
								"qualifiedName": "vehicle.cars.datsun.go",
								"displayName": "Go",
								"children": [],
								"score": 194,
								"description": "Go",
								"identifier": 195,
								"item_id": 41,
								"version": "1"
							}
						],
						"score": 194
					},
					{
						"name": "chevrolet",
						"qualifiedName": "vehicle.cars.chevrolet",
						"displayName": "Chevrolet",
						"children": [
							{
								"name": "spark",
								"qualifiedName": "vehicle.cars.chevrolet.spark",
								"displayName": "Spark",
								"children": [],
								"score": 195,
								"description": "Spark",
								"identifier": 196,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "beat",
								"qualifiedName": "vehicle.cars.chevrolet.beat",
								"displayName": "Beat",
								"children": [],
								"score": 196,
								"description": "Beat",
								"identifier": 197,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "sailHatchback",
								"qualifiedName": "vehicle.cars.chevrolet.sailHatchback",
								"displayName": "Sail Hatchback",
								"children": [],
								"score": 197,
								"description": "Sail Hatchback",
								"identifier": 198,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "sail",
								"qualifiedName": "vehicle.cars.chevrolet.sail",
								"displayName": "Sail",
								"children": [],
								"score": 198,
								"description": "Sail",
								"identifier": 199,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "enjoy",
								"qualifiedName": "vehicle.cars.chevrolet.enjoy",
								"displayName": "Enjoy",
								"children": [],
								"score": 199,
								"description": "Enjoy",
								"identifier": 200,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "tavera",
								"qualifiedName": "vehicle.cars.chevrolet.tavera",
								"displayName": "Tavera",
								"children": [],
								"score": 200,
								"description": "Tavera",
								"identifier": 201,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "cruze",
								"qualifiedName": "vehicle.cars.chevrolet.cruze",
								"displayName": "Cruze",
								"children": [],
								"score": 201,
								"description": "Cruze",
								"identifier": 202,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "captiva",
								"qualifiedName": "vehicle.cars.chevrolet.captiva",
								"displayName": "Captiva",
								"children": [],
								"score": 202,
								"description": "Captiva",
								"identifier": 203,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "trailblazer",
								"qualifiedName": "vehicle.cars.chevrolet.trailblazer",
								"displayName": "Trailblazer",
								"children": [],
								"score": 203,
								"description": "Trailblazer",
								"identifier": 204,
								"item_id": 41,
								"version": "1"
							}
						],
						"score": 195
					},
					{
						"name": "renault",
						"qualifiedName": "vehicle.cars.renault",
						"displayName": "Renault",
						"children": [
							{
								"name": "kwid",
								"qualifiedName": "vehicle.cars.renault.kwid",
								"displayName": "Kwid",
								"children": [],
								"score": 204,
								"description": "Kwid",
								"identifier": 205,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "pulse",
								"qualifiedName": "vehicle.cars.renault.pulse",
								"displayName": "Pulse",
								"children": [],
								"score": 205,
								"description": "Pulse",
								"identifier": 206,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "scala",
								"qualifiedName": "vehicle.cars.renault.scala",
								"displayName": "Scala",
								"children": [],
								"score": 206,
								"description": "Scala",
								"identifier": 207,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "lodgy",
								"qualifiedName": "vehicle.cars.renault.lodgy",
								"displayName": "Lodgy",
								"children": [],
								"score": 207,
								"description": "Lodgy",
								"identifier": 208,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "duster",
								"qualifiedName": "vehicle.cars.renault.duster",
								"displayName": "Duster",
								"children": [],
								"score": 208,
								"description": "Duster",
								"identifier": 209,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "fluence",
								"qualifiedName": "vehicle.cars.renault.fluence",
								"displayName": "Fluence",
								"children": [],
								"score": 209,
								"description": "Fluence",
								"identifier": 210,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "koleos",
								"qualifiedName": "vehicle.cars.renault.koleos",
								"displayName": "Koleos",
								"children": [],
								"score": 210,
								"description": "Koleos",
								"identifier": 211,
								"item_id": 41,
								"version": "1"
							}
						],
						"score": 204
					},
					{
						"name": "audi",
						"qualifiedName": "vehicle.cars.audi",
						"displayName": "Audi",
						"children": [
							{
								"name": "audiA3",
								"qualifiedName": "vehicle.cars.audi.audiA3",
								"displayName": "Audi A3",
								"children": [],
								"score": 211,
								"description": "Audi A3",
								"identifier": 212,
								"item_id": 41,
								"version": "1"
							}
						],
						"score": 211
					},
					{
						"name": "mercedeshyphenBenz",
						"qualifiedName": "vehicle.cars.mercedeshyphenBenz",
						"displayName": "Mercedes-Benz",
						"children": [
							{
								"name": "ahyphenClass",
								"qualifiedName": "vehicle.cars.mercedeshyphenBenz.ahyphenClass",
								"displayName": "A-Class",
								"children": [],
								"score": 212,
								"description": "A-Class",
								"identifier": 213,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "bhyphenClass",
								"qualifiedName": "vehicle.cars.mercedeshyphenBenz.bhyphenClass",
								"displayName": "B-Class",
								"children": [],
								"score": 213,
								"description": "B-Class",
								"identifier": 214,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "clAhyphenClass",
								"qualifiedName": "vehicle.cars.mercedeshyphenBenz.clAhyphenClass",
								"displayName": "CLA-Class",
								"children": [],
								"score": 214,
								"description": "CLA-Class",
								"identifier": 215,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "glAhyphenClass",
								"qualifiedName": "vehicle.cars.mercedeshyphenBenz.glAhyphenClass",
								"displayName": "GLA-Class",
								"children": [],
								"score": 215,
								"description": "GLA-Class",
								"identifier": 216,
								"item_id": 41,
								"version": "1"
							}
						],
						"score": 212
					},
					{
						"name": "nissan",
						"qualifiedName": "vehicle.cars.nissan",
						"displayName": "Nissan",
						"children": [
							{
								"name": "micra",
								"qualifiedName": "vehicle.cars.nissan.micra",
								"displayName": "Micra",
								"children": [],
								"score": 216,
								"description": "Micra",
								"identifier": 217,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "sunny",
								"qualifiedName": "vehicle.cars.nissan.sunny",
								"displayName": "Sunny",
								"children": [],
								"score": 217,
								"description": "Sunny",
								"identifier": 218,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "evalia",
								"qualifiedName": "vehicle.cars.nissan.evalia",
								"displayName": "Evalia",
								"children": [],
								"score": 218,
								"description": "Evalia",
								"identifier": 219,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "teana",
								"qualifiedName": "vehicle.cars.nissan.teana",
								"displayName": "Teana",
								"children": [],
								"score": 219,
								"description": "Teana",
								"identifier": 220,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "terrano",
								"qualifiedName": "vehicle.cars.nissan.terrano",
								"displayName": "Terrano",
								"children": [],
								"score": 220,
								"description": "Terrano",
								"identifier": 221,
								"item_id": 41,
								"version": "1"
							}
						],
						"score": 216
					},
					{
						"name": "bmw",
						"qualifiedName": "vehicle.cars.bmw",
						"displayName": "BMW",
						"children": [
							{
								"name": "1Series",
								"qualifiedName": "vehicle.cars.bmw.1Series",
								"displayName": "1 Series",
								"children": [],
								"score": 221,
								"description": "1 Series",
								"identifier": 222,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "3Series",
								"qualifiedName": "vehicle.cars.bmw.3Series",
								"displayName": "3 Series",
								"children": [],
								"score": 222,
								"description": "3 Series",
								"identifier": 223,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "x1",
								"qualifiedName": "vehicle.cars.bmw.x1",
								"displayName": "X1",
								"children": [],
								"score": 223,
								"description": "X1",
								"identifier": 224,
								"item_id": 41,
								"version": "1"
							}
						],
						"score": 221
					},
					{
						"name": "skoda",
						"qualifiedName": "vehicle.cars.skoda",
						"displayName": "Skoda",
						"children": [
							{
								"name": "rapid",
								"qualifiedName": "vehicle.cars.skoda.rapid",
								"displayName": "Rapid",
								"children": [],
								"score": 224,
								"description": "Rapid",
								"identifier": 225,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "octavia",
								"qualifiedName": "vehicle.cars.skoda.octavia",
								"displayName": "Octavia",
								"children": [],
								"score": 225,
								"description": "Octavia",
								"identifier": 226,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "fabia",
								"qualifiedName": "vehicle.cars.skoda.fabia",
								"displayName": "Fabia",
								"children": [],
								"score": 226,
								"description": "Fabia",
								"identifier": 227,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "yeti",
								"qualifiedName": "vehicle.cars.skoda.yeti",
								"displayName": "Yeti",
								"children": [],
								"score": 227,
								"description": "Yeti",
								"identifier": 228,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "superb",
								"qualifiedName": "vehicle.cars.skoda.superb",
								"displayName": "Superb",
								"children": [],
								"score": 228,
								"description": "Superb",
								"identifier": 229,
								"item_id": 41,
								"version": "1"
							}
						],
						"score": 224
					},
					{
						"name": "fiat",
						"qualifiedName": "vehicle.cars.fiat",
						"displayName": "Fiat",
						"children": [
							{
								"name": "punto",
								"qualifiedName": "vehicle.cars.fiat.punto",
								"displayName": "Punto",
								"children": [],
								"score": 229,
								"description": "Punto",
								"identifier": 230,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "linea",
								"qualifiedName": "vehicle.cars.fiat.linea",
								"displayName": "Linea",
								"children": [],
								"score": 230,
								"description": "Linea",
								"identifier": 231,
								"item_id": 41,
								"version": "1"
							},
							{
								"name": "avventura",
								"qualifiedName": "vehicle.cars.fiat.avventura",
								"displayName": "Avventura",
								"children": [],
								"score": 231,
								"description": "Avventura",
								"identifier": 232,
								"item_id": 41,
								"version": "1"
							}
						],
						"score": 229
					},
					{
						"name": "ssangyong",
						"qualifiedName": "vehicle.cars.ssangyong",
						"displayName": "Ssangyong",
						"children": [
							{
								"name": "rexton",
								"qualifiedName": "vehicle.cars.ssangyong.rexton",
								"displayName": "Rexton",
								"children": [],
								"score": 232,
								"description": "Rexton",
								"identifier": 233,
								"item_id": 41,
								"version": "1"
							}
						],
						"score": 232
					},
					{
						"name": "eicher",
						"qualifiedName": "vehicle.cars.eicher",
						"displayName": "Eicher",
						"children": [
							{
								"name": "polarisMultix",
								"qualifiedName": "vehicle.cars.eicher.polarisMultix",
								"displayName": "Polaris Multix",
								"children": [],
								"score": 233,
								"description": "Polaris Multix",
								"identifier": 234,
								"item_id": 41,
								"version": "1"
							}
						],
						"score": 233
					},
					{
						"name": "isuzu",
						"qualifiedName": "vehicle.cars.isuzu",
						"displayName": "Isuzu",
						"children": [
							{
								"name": "mu7",
								"qualifiedName": "vehicle.cars.isuzu.mu7",
								"displayName": "MU7",
								"children": [],
								"score": 234,
								"description": "MU7",
								"identifier": 235,
								"item_id": 41,
								"version": "1"
							}
						],
						"score": 234
					}
				],
				"score": 122,
				"item_id": 41
			},
			{
				"name": "cycles",
				"qualifiedName": "vehicle.cycles",
				"displayName": "Cycles",
				"children": [
					{
						"name": "withGear",
						"qualifiedName": "vehicle.cycles.withGear",
						"displayName": "With Gear",
						"children": [
							{
								"name": "cycleWithGear",
								"qualifiedName": "vehicle.cycles.withGear.cycleWithGear",
								"displayName": "Cycle with gear",
								"children": [],
								"score": 235,
								"description": "Cycle with gear",
								"identifier": 236,
								"item_id": 40,
								"version": "1"
							}
						],
						"score": 235
					},
					{
						"name": "withoutGear",
						"qualifiedName": "vehicle.cycles.withoutGear",
						"displayName": "Without Gear",
						"children": [
							{
								"name": "cycleWithoutGear",
								"qualifiedName": "vehicle.cycles.withoutGear.cycleWithoutGear",
								"displayName": "Cycle without gear",
								"children": [],
								"score": 236,
								"description": "Cycle without gear",
								"identifier": 237,
								"item_id": 40,
								"version": "1"
							}
						],
						"score": 236
					}
				],
				"score": 235,
				"item_id": 40
			}
		]
	}
];


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./client/app/common/inventory/VEHICLE_INVENTORY.json
// module id = 207
// module chunks = 0